import { arts } from "./arts";
import { settings } from "../common/setting";

interface Update {
  dom: HTMLElement | null;
  html: string;
}

export function renderAdd(data, type, pcfn, wapfn): string {
  const pc = pcfn || arts[type].pc;
  const wap = wapfn || arts[type].wap;
  const html = type == 1 ? pc(data) : wap(data);
  return `<sk-temp id="${data.type}_${data.id}" class="sk-component ${
    data.type
  } ${
    settings.isPreview && settings.isDesign == 1 ? "sk-component-preview" : ""
  }" data-component-id="${data.id}">${html}</sk-temp>`;
}

export function renderUpdate(data, type, pcfn, wapfn): Update {
  const pc = pcfn || arts[type].pc;
  const wap = wapfn || arts[type].wap;
  const dom = document.getElementById(`${data.type}_${data.id}`);
  const html = type == 1 ? pc(data) : wap(data);
  if (dom) {
    return {
      dom,
      html,
    };
  }
  return {
    dom: null,
    html,
  };
}

// 轮播添加
export function RENDER_CAROUSEL(data, type) {
  return renderAdd(data, type, arts.CAROUSEL.pc, arts.CAROUSEL.wap);
}
// 轮播更新
export function RENDER_CAROUSEL_UPDATE(data, type): Update {
  return renderUpdate(data, type, arts.CAROUSEL.pc, arts.CAROUSEL.wap);
}

// 底部添加
export function RENDER_FOOTER(data, type) {
  return renderAdd(data, type, arts.FOOTER.pc, arts.FOOTER.wap);
}
// 底部更新
export function RENDER_FOOTER_UPDATE(data, type): Update {
  return renderUpdate(data, type, arts.FOOTER.pc, arts.FOOTER.wap);
}

// 多图列表添加
export function RENDER_MIMAGE(data, type) {
  return renderAdd(data, type, arts.MIMAGE.pc, arts.MIMAGE.wap);
}
// 多图列表更新
export function RENDER_MIMAGE_UPDATE(data, type): Update {
  return renderUpdate(data, type, arts.MIMAGE.pc, arts.MIMAGE.wap);
}

// 多图文、文章列表添加
export function RENDER_MIMAGETEXT(data, type) {
  return renderAdd(data, type, arts.MIMAGETEXT.pc, arts.MIMAGETEXT.wap);
}
// 多图文、文章列表更新
export function RENDER_MIMAGETEXT_UPDATE(data, type): Update {
  return renderUpdate(data, type, arts.MIMAGETEXT.pc, arts.MIMAGETEXT.wap);
}

// 导航添加
export function RENDER_NAV(data, type) {
  return renderAdd(data, type, arts.NAV.pc, arts.NAV.wap);
}
// 导航更新
export function RENDER_NAV_UPDATE(data, type): Update {
  return renderUpdate(data, type, arts.NAV.pc, arts.NAV.wap);
}

// 自定义、富文本添加
export function RENDER_CUSTOMCONTENT(data, type) {
  return renderAdd(data, type, arts.CUSTOMCONTENT.pc, arts.CUSTOMCONTENT.wap);
}
// 自定义、富文本更新
export function RENDER_CUSTOMCONTENT_UPDATE(data, type): Update {
  return renderUpdate(
    data,
    type,
    arts.CUSTOMCONTENT.pc,
    arts.CUSTOMCONTENT.wap
  );
}

// 单图添加
export function RENDER_SIMAGE(data, type) {
  return renderAdd(data, type, arts.SIMAGE.pc, arts.SIMAGE.wap);
}
// 单图更新
export function RENDER_SIMAGE_UPDATE(data, type): Update {
  return renderUpdate(data, type, arts.SIMAGE.pc, arts.SIMAGE.wap);
}

// 单图文添加
export function RENDER_SIMAGETEXT(data, type) {
  return renderAdd(data, type, arts.SIMAGETEXT.pc, arts.SIMAGETEXT.wap);
}
// 单图文更新
export function RENDER_SIMAGETEXT_UPDATE(data, type): Update {
  return renderUpdate(data, type, arts.SIMAGETEXT.pc, arts.SIMAGETEXT.wap);
}

// 表单添加
export function RENDER_CUSTOMFORM(data, type) {
  return renderAdd(data, type, arts.CUSTOMFORM.pc, arts.CUSTOMFORM.wap);
}
// 表单更新
export function RENDER_CUSTOMFORM_UPDATE(data, type) {
  return renderUpdate(data, type, arts.CUSTOMFORM.pc, arts.CUSTOMFORM.wap);
}

// 会议列表添加
export function RENDER_MEETING(data, type) {
  return renderAdd(data, type, arts.MEETING.pc, arts.MEETING.wap);
}
// 会议列表更新
export function RENDER_MEETING_UPDATE(data, type) {
  return renderUpdate(data, type, arts.MEETING.pc, arts.MEETING.wap);
}

// 文章详情添加
export function RENDER_ARTICLEDETAIL(data, type) {
  return renderAdd(data, type, arts.ARTICLEDETAIL.pc, arts.ARTICLEDETAIL.wap);
}
// 文章详情更新
export function RENDER_ARTICLEDETAIL_UPDATE(data, type) {
  return renderUpdate(
    data,
    type,
    arts.ARTICLEDETAIL.pc,
    arts.ARTICLEDETAIL.wap
  );
}

// 文章详情Banner添加
export function RENDER_ARTICLEDETAILBANNER(data, type) {
  return renderAdd(
    data,
    type,
    arts.ARTICLEDETAILBANNER.pc,
    arts.ARTICLEDETAILBANNER.wap
  );
}
// 文章详情Banner更新
export function RENDER_ARTICLEDETAILBANNER_UPDATE(data, type) {
  return renderUpdate(
    data,
    type,
    arts.ARTICLEDETAILBANNER.pc,
    arts.ARTICLEDETAILBANNER.wap
  );
}

// 视频列表添加
export function RENDER_VIDEO(data, type) {
  return renderAdd(data, type, arts.VIDEO.pc, arts.VIDEO.wap);
}
// 视频列表更新
export function RENDER_VIDEO_UPDATE(data, type) {
  return renderUpdate(data, type, arts.VIDEO.pc, arts.VIDEO.wap);
}

// 文件组件添加
export function RENDER_FILE(data, type) {
  return renderAdd(data, type, arts.FILE.pc, arts.FILE.wap);
}
// 文件组件更新
export function RENDER_FILE_UPDATE(data, type) {
  return renderUpdate(data, type, arts.FILE.pc, arts.FILE.wap);
}

// 注册组件添加
export function RENDER_REGISTRATION(data, type) {
  return renderAdd(data, type, arts.REGISTRATION.pc, arts.REGISTRATION.wap);
}
// 注册组件更新
export function RENDER_REGISTRATION_UPDATE(data, type) {
  return renderUpdate(data, type, arts.REGISTRATION.pc, arts.REGISTRATION.wap);
}

// 侧边栏组件添加
export function RENDER_SIDEBAR(data, type) {
  return renderAdd(data, type, arts.SIDEBAR.pc, arts.SIDEBAR.wap);
}
// 侧边栏组件更新
export function RENDER_SIDEBAR_UPDATE(data, type) {
  return renderUpdate(data, type, arts.SIDEBAR.pc, arts.SIDEBAR.wap);
}

// 暂无组件添加
export function RENDER_NULL(data, type) {
  return renderAdd(data, type, arts.NULL.pc, arts.NULL.wap);
}
// 暂无组件更新
export function RENDER_NULL_UPDATE(data, type) {
  return renderUpdate(data, type, arts.NULL.pc, arts.NULL.wap);
}
// TAB组件添加
export function RENDER_TAB(data, type) {
  return renderAdd(data, type, arts.TAB.pc, arts.TAB.wap);
}

export function RENDER_FILEDETAIL(data, type) {
  return renderAdd(data, type, arts.FILEDETAIL.pc, arts.FILEDETAIL.wap);
}

export function RENDER_FILEDETAIL_UPDATE(data, type) {
  return renderUpdate(data, type, arts.FILEDETAIL.pc, arts.FILEDETAIL.wap);
}

export function RENDER_SEARCH(data, type) {
  return renderAdd(data, type, arts.SEARCH.pc, arts.SEARCH.wap);
}

export function RENDER_SEARCH_UPDATE(data, type) {
  return renderUpdate(data, type, arts.SEARCH.pc, arts.SEARCH.wap);
}

export function RENDER_SEARCHDETAIL(data, type) {
  return renderAdd(data, type, arts.SEARCHDETAIL.pc, arts.SEARCHDETAIL.wap);
}

export function RENDER_SEARCHDETAIL_UPDATE(data, type) {
  return renderUpdate(data, type, arts.SEARCHDETAIL.pc, arts.SEARCHDETAIL.wap);
}
